export const isZeroOrTruthy = (value: any) => value === 0 || !!value;
